import React, {useEffect} from 'react'
import {updateSingleQuote} from "../common/services/quote-data-service";
import SelectThemes from "../theme/components/select-themes";
import _ from "lodash";
import SelectTags from "../tag/select-tags";

const QuoteDetail = ({selectedQuote, setSelectedQuote, allThemes, allTags}) => {

    const handleSelectQuoteChanges = async (event) => {
        const {name, value} = event.target;
        const quote = {...selectedQuote};
        quote[name] = value;

        if (name === 'themeList') {
            const tempThemes = {};
            _.forEach(value, themeId => {
                tempThemes[themeId] = true;
            });

            quote['themes'] = tempThemes;
            quote['themeList'] = value;
        }

        if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            quote['tags'] = tempTags;
            quote['tagList'] = value;
        }

        setSelectedQuote(quote);
        await updateSingleQuote(quote);
    }

    return (
        <>

            <div className="flex justify-between mb-7">
                <div className="title-label">
                    {selectedQuote?.startText}
                </div>

                <div className="float-right">
                    <a href={`/quotes/${selectedQuote?.id}/designs`} className="button-medium">
                        <span>Add Designs</span>
                    </a>
                </div>
            </div>

            <div className="overflow-y-scroll form-container">

                {selectedQuote &&
                    <>
                        <div className="field-group-container">
                            <div className="field-container w-1/2">
                                <div className="field-label">Start Text</div>
                                <input type="text" placeholder="Start Text"
                                       id="startText"
                                       name="startText"
                                       value={selectedQuote?.startText}
                                       onChange={handleSelectQuoteChanges}
                                       className="input-field w-full"/>
                            </div>

                            <div className="field-container w-1/2">
                                <div className="field-label">Text</div>
                                <input type="text" placeholder="Text"
                                       id="text"
                                       name="text"
                                       value={selectedQuote?.text}
                                       readOnly={true}
                                       className="input-field read-only-field w-full"/>
                            </div>
                        </div>

                        <div className="field-group-container">
                            <div className="field-container w-full">
                                <div className="field-label">Display Text</div>
                                <textarea
                                    id="displayText"
                                    name="displayText"
                                    value={selectedQuote?.displayText}
                                    onChange={handleSelectQuoteChanges}
                                    className="text-area-field"/>
                            </div>
                        </div>

                        <div className="field-group-container">
                            <div className="field-container w-full">
                                <div className="field-label">Description</div>
                                <textarea
                                    id="description"
                                    name="description"
                                    value={selectedQuote?.description || ''}
                                    onChange={handleSelectQuoteChanges}
                                    className="text-area-field"/>
                            </div>
                        </div>

                        <div>
                            {allThemes &&
                                <div
                                    className="h-40 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mx-2 mt-2">
                                    <SelectThemes
                                        existingThemes={selectedQuote?.themeList}
                                        allThemes={allThemes}
                                        handleSelectThemesChanges={handleSelectQuoteChanges}
                                        showClearSelectedThemes={false}
                                        showClearSelectedThemesIcon={false}/>
                                </div>
                            }
                        </div>

                        <div>
                            {allTags &&
                                <div
                                    className="h-80 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mx-2 mt-2 shadow-xl">
                                    <SelectTags
                                        existingTags={selectedQuote?.tagList}
                                        allTags={allTags}
                                        handleSelectTagsChanges={handleSelectQuoteChanges}
                                        showAddTag={true}
                                        showClearSelectedTags={false}
                                        showClearSelectedTagsIcon={false}/>
                                </div>
                            }
                        </div>
                    </>
                }

            </div>
        </>
    )
}

export default QuoteDetail
